import React, { useCallback, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { DataAuditoriaDropDown } from '../domain/models/data_auditoria_dropdown';
import { DataCronogramaSGQDropDown } from '../domain/models/data_cronogramaSGQ__dropdown';
import { FuncionarioDropDown } from '../domain/models/funcionario_dropdown';

type Props = {
  name: string;
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined; 
  onChange: (newValue: string | number | undefined) => void; 
  error?: boolean;
  helperText?: string | null;
};

export const DefaultFuncioanrio = ({
  name,
  label,
  required,
  readOnly,
  placeholder,
  disabled,
  value,
  onChange,
  error,
  helperText,
}: Props) => {

  const { pushErrorNotification, pushInfoNotification } = usePageLoader();
  const [funcionarioDropDown, setFuncionarioDropDown] = useState<FuncionarioDropDown[]>([]);

  const {
    commons: {
      getFuncionariosDropDownUseCase,
    },
  } = useDependencyInjection();

  const loadFuncionariosDropDown = useCallback(async () => {
    try {
      const result = await getFuncionariosDropDownUseCase.getFuncionariosDropDown();
      setFuncionarioDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar datas CronogramaSGQ!'));
    }
  }, [getFuncionariosDropDownUseCase, pushErrorNotification]);

  usePageStartBootstrap(async () => {
    loadFuncionariosDropDown();
  });


  return (
    <>
     <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={funcionarioDropDown}
        getOptionLabel={(opt) => String(opt.nome)}
        isOptionEqualToValue={(opt, val) => String(opt.nome) === String(val.nome)} 
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled}
        value={funcionarioDropDown.find(x => String(x.idFuncionario) === String(value)) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.idFuncionario : undefined);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            required={required}
          />
        )}
      />
    </>
  );
};